import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import styled from 'styled-components';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Componentes
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import ProviderProfile from './pages/ProviderProfile';
import UserProfile from './pages/UserProfile';
import SearchResults from './pages/SearchResults';
import ProfessionalRegister from './pages/ProfessionalRegister';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ProviderDashboard from './pages/ProviderDashboard';
import ProfessionalDashboard from './pages/ProfessionalDashboard';
import PlansPage from './pages/PlansPage';

// Tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
  },
});

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <AppContainer>
            <Navbar />
            <Content>
              <Routes>
                <Route path="/" element={<UserProfile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/register/professional" element={<ProfessionalRegister />} />
                <Route 
                  path="/provider/dashboard" 
                  element={
                    <ProtectedRoute requiredUserType="provider">
                      <ProviderDashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/provider/:id" element={<ProviderProfile />} />
                <Route path="/user/:id" element={<UserProfile />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute requiredUserType="provider">
                      <ProfessionalDashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/plans" 
                  element={
                    <ProtectedRoute requiredUserType="provider">
                      <PlansPage />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </Content>
          </AppContainer>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
